import { useEffect, useContext } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useIsInBucket } from '@carvana/purchase-helpers';

const usePurchaseHeaderEvent = () => {
  const { trackEvent } = useContext(AnalyticsContext);

  const isInPurchaseHeaderBucket = useIsInBucket(
    'pp-purchase-header-dec-2023',
    'purchase-header',
    ['control']
  );

  const sendHeaderLoadEvent = () => {
    if (isInPurchaseHeaderBucket) trackEvent('carvana-page-load');
  };

  useEffect(() => sendHeaderLoadEvent(), [isInPurchaseHeaderBucket, trackEvent]);
};

export default usePurchaseHeaderEvent;
